import React, { useState, useRef, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header_new';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { FaAngleDoubleRight } from 'react-icons/fa';

const BaseLayout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);

  // Fecha dropdown ao clicar fora
  useEffect(() => {
    function handleClickOutside(event) {
      if (isDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(event.target) && !event.target.closest('.menu-hamburger-btn')) {
        setIsMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen, isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="flex flex-col min-h-screen relative">
      {/* Overlay para menu hamburguer */}
      {isMenuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-20 transition-opacity duration-300" />
      )}
      <Header
        onMenuClick={toggleMenu}
        onDropdownClick={toggleDropdown}
        isDropdownOpen={isDropdownOpen}
        dropdownRef={dropdownRef}
      />
      <div className="flex flex-1 min-w-0">
        <Sidebar 
          ref={menuRef} 
          isMenuOpen={isMenuOpen} 
          isCollapsed={isSidebarCollapsed} 
          onToggleCollapse={toggleSidebar}
        />
        {/* Botão flutuante para expandir sidebar quando recolhida */}
        {isSidebarCollapsed && (
          <button
            onClick={toggleSidebar}
            className="hidden lg:flex fixed left-2 top-16 z-40 items-center justify-center w-8 h-8 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:bg-indigo-50 group"
            title="Expandir menu"
          >
            <FaAngleDoubleRight className="text-gray-600 group-hover:text-indigo-600 transition-colors duration-200" />
          </button>
        )}
        <main className={`flex-1 bg-gray-50 p-2 sm:p-4 md:p-6 min-w-0 overflow-x-hidden transition-all duration-300 ${isSidebarCollapsed ? 'lg:ml-0' : ''}`}>
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default BaseLayout;
